'use strict';

import User from './user';

class AuthService {
  constructor ($http, $q, $rootScope) {
    this.$http = $http;
    this.$q = $q;
    this.$rootScope = $rootScope;
  }

  isLoggedIn() {
    if(this.$rootScope.user) {
      return true;
    } else {
      return false;
    }
  }

  login(id, password, remember){
    var deferred = this.$q.defer();
    var data = {
      'username': id,
      'password': password,
      'remember-me': remember
    };

    var self = this;
    this.$http.post('/login', jQuery.param(data),
      {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        ignoreAuthModule: true
      })
      .then(function(data){
        var that = self;
        if(data.status === 200){
          self.$http.get('/api/users/current').then(function(response){
            that.$rootScope.user = User.build(response.data);
            that.$rootScope.user.remember = remember;
            deferred.resolve(response);
          });
        } else {
          that.$rootScope.user = false;
          deferred.reject(data);
        }
      },
      function(data){
        self.$rootScope.user = false;
        deferred.reject(data);
      });

    return deferred.promise;
  }

  logout(){
    var deferred = this.$q.defer();

    var self = this;
    this.$http.post('/logout', {ignoreAuthModule: true}).then(
      function () {
        self.$rootScope.user = false;
        deferred.resolve();
      },
      function () {
        self.$rootScope.user = false;
        deferred.reject();
      });

    // return promise object
    return deferred.promise;
  }
}

AuthService.$inject = ['$http', '$q', '$rootScope'];
export default AuthService;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/services/authservice.js